import { autoUpdate, computePosition, flip, shift } from '@floating-ui/dom'
import { EditorView } from 'prosemirror-view'
import { ReactElement } from 'react'
import { render, unmountComponentAtNode } from 'react-dom'
import { isMobile } from 'utils/isMobile'
import Styles from './Prompt.module.scss'

type CreatePromptArgs = {
  view: EditorView
  prompt: (close: () => void) => ReactElement
  mobileEnabled?: boolean
  centered?: boolean
  // if not centered, provide ref element to position prompt with optional left position or specific position
  refElement?: HTMLElement
  left?: number
  position?: { top: number; left: number }
}

export const createPrompt = ({
  view,
  prompt,
  mobileEnabled,
  centered = false,
  refElement,
  left,
  position,
}: CreatePromptArgs) => {
  if (!(centered || refElement || position)) throw new Error('Must provide refElement or position if not centered')
  const wrapper = document.createElement('div')
  wrapper.className = Styles.promptWrapper
  const parent = document.querySelector('#floating-ui-root')
  if (!parent) throw new Error('No #floating-ui-root found')
  const mobile = isMobile()

  if (mobileEnabled && mobile) {
    parent.appendChild(wrapper)
  } else if (centered) {
    wrapper.classList.add(Styles.centered)
    parent.appendChild(wrapper)
  } else if (position) {
    Object.assign(wrapper.style, {
      left: `${position.left}px`,
      top: `${position.top}px`,
      opacity: '1',
    })
    parent.appendChild(wrapper)
  } else {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    autoUpdate(refElement!, wrapper, () => {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      computePosition(refElement!, wrapper, {
        placement: 'bottom-end',
        middleware: [flip(), shift()],
      }).then(({ x, y }) => {
        if (left) {
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          Object.assign(wrapper!.style, {
            left: `${left}px`,
            top: `${y}px`,
            opacity: '1',
          })
        } else {
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          Object.assign(wrapper!.style, {
            left: `${x}px`,
            top: `${y}px`,
            opacity: '1',
          })
        }
      })
    })

    parent.appendChild(wrapper)
  }

  const close = () => {
    unmountComponentAtNode(wrapper)
    wrapper.remove()
    view.focus()
  }

  render(prompt(close), wrapper)
}
